import React from 'react';
import { LayoutGrid, List } from 'lucide-react';

function ViewToggle({ view, onChange }) {
  const base = 'w-8 h-8 flex items-center justify-center rounded-lg text-muted transition-colors';
  return (
    <div className="flex items-center gap-1 bg-white border border-line rounded-[10px] p-1">
      <button
        aria-label="ग्रिड दृश्य"
        className={`${base} ${view === 'grid' ? 'bg-crimson text-white' : 'hover:text-crimson'}`}
        onClick={() => onChange('grid')}
      >
        <LayoutGrid size={16} />
      </button>
      <button
        aria-label="सूची दृश्य"
        className={`${base} ${view === 'list' ? 'bg-crimson text-white' : 'hover:text-crimson'}`}
        onClick={() => onChange('list')}
      >
        <List size={16} />
      </button>
    </div>
  );
}

export default ViewToggle;